import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { FiUpload } from 'react-icons/fi';
import { ContainerDrop } from './styles';

const Dropzone = ({ selectedFile = "",onFileUploaded }) => {

  const onDrop = useCallback((acceptFiles)=> {
    const file = acceptFiles[0];
    onFileUploaded(file);
  }, [onFileUploaded]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop, 
  });

  const selectedFileUrl = selectedFile ? URL.createObjectURL(selectedFile) : "";
  
  return (
    <ContainerDrop {...getRootProps()}>
      <input {...getInputProps()} />

      {selectedFileUrl ? (
        <img src={selectedFileUrl} alt={selectedFile?.name || 'Arquivo a ser escolhido'} />
      ) : (
        <p>
          <FiUpload />
          Arquivo a ser enviado pro servidor
        </p>
      )}
    </ContainerDrop>
  )
}

export default Dropzone;
